import * as queries from "../../graphql/queries";
import {
  GetProgramMembershipQuery,
  ModelProgramMembershipConnection,
  ProgramMembership,
  UsersByProgramQuery
} from "../../API";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";

export const fetchProgramMembershipsByProgramId = async (programId: string) => {
  const predicate = { programId: programId };
  return await listQueryAutoPaginated<
    UsersByProgramQuery,
    ProgramMembership,
    ModelProgramMembershipConnection
  >(queries.usersByProgram, "usersByProgram", "items", predicate);
};

export const fetchProgramMembership = async (id: string) => {
  const predicate = { id: id };
  return await genericQuery<GetProgramMembershipQuery, ProgramMembership>(
    queries.getProgramMembership,
    "getProgramMembership",
    predicate
  );
};

export const fetchProgramMembershipByUserAndProgram = async (
  userId: string,
  programId: string
) => {
  const predicate = { programId };
  const results = await listQueryAutoPaginated<
    UsersByProgramQuery,
    ProgramMembership,
    ModelProgramMembershipConnection
  >(queries.usersByProgram, "usersByProgram", "items", predicate);
  return results?.find((r) => r.programMemberId == userId) ?? null;
};
